import React from "react";
import EarthCanvas from "../shader/EarthCanvas";
import HeroContent from "../components/HeroContent";
import Stars from "../components/Stars";

const Hero = () => {
  return (
    <div className="stars-main">
      <div className="stars-main">
        <Stars />
        <HeroContent />
        <div
          className="flex  items-center justify-center relative z-50"
          style={{ height: "70vh", width: "50vw" }}
        >
          <EarthCanvas />
        </div>
      </div>
    </div>
  );
};

export default Hero;
